import { Component, OnInit, ViewChild } from '@angular/core';
import { IMyDpOptions } from 'mydatepicker';
import { FormBuilder } from '@angular/forms';
import * as moment from 'moment';
import { SpringDatatablePagination } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { SpringDatatablePaginationService } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { HttpParams } from '@angular/common/http';
import { DateUtilService } from '../../../shared/services/date-util.service';
import { ExportCsvService } from '../../../shared/services/export-csv.service';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { DatatableService } from '../../../shared/services/datatable.service';
import { DatatableComponent, DataTablePagerComponent } from '@swimlane/ngx-datatable';
import { ConsultaFinanceiraService } from './consulta-financeira.service';

@Component({
  selector: 'ngx-consulta-financeira',
  templateUrl: './consulta-financeira.component.html',
  styleUrls: ['./consulta-financeira.component.scss']
})
export class ConsultaFinanceiraComponent implements OnInit {

  @ViewChild('myTable', null)
  private myTable: DatatableComponent

  @ViewChild('tablePager', null)
  public tablePager: DataTablePagerComponent;

  public formConsultaFinanceira = null;
  public extratoLote = null;
  public extrato = null;
  public rowData = null;
  public columnsTabe = null;
  public tableLimit = 20;
  public listTipoConta = null;
  public listTipoOperacao = null;
  public cnpjCpf = null;

  datatablePagination: SpringDatatablePagination = new SpringDatatablePagination()

  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    showClearDateBtn: false,
    openSelectorOnInputClick: true,
    showTodayBtn: false,
    allowSelectionOnlyInCurrentMonth: false,
    dayLabels: { su: "Dom", mo: "Seg", tu: "Ter", we: "Qua", th: "Qui", fr: "Sex", sa: "Sab" },
    monthLabels: { 1: "Jan", 2: "Fev", 3: "Mar", 4: "Abr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Ago", 9: "Set", 10: "Out", 11: "Nov", 12: "Dez" },
    firstDayOfWeek: "su",

  };

  constructor(
    private formBuilder: FormBuilder,
    private paginationService: SpringDatatablePaginationService,
    private service: ConsultaFinanceiraService,
    private dateUtilService: DateUtilService,
    private exportCsvService: ExportCsvService,
    private router: Router,
    private notificationService: NotificationsService,
    private datatableService: DatatableService,
  ) {

    this.paginationService.setDatatablePagination(this.datatablePagination);

    this.listTipoConta = [
      {
        tipoConta: 'TOP_PESSOA',
        descricao: 'TOP PESSOA'
      },
      {
        tipoConta: 'TOP_EMPRESA',
        descricao: 'TOP EMPRESA'
      },

    ];

    this.listTipoOperacao = [
      {
        tipoOperacao: 'AUTHOTIZATION',
        descricao: 'AUTHOTIZATION'
      },
      {
        tipoOperacao: 'PRIMEIRA_VIA',
        descricao: 'PRIMEIRA VIA'
      },
      {
        tipoOperacao: 'RECARGA',
        descricao: 'RECARGA'
      },
      {
        tipoOperacao: 'SEGUNDA_VIA',
        descricao: 'SEGUNDA VIA'
      },
      {
        tipoOperacao: 'BOLETO',
        descricao: 'BOLETO'
      },
      {
        tipoOperacao: 'ONLINE',
        descricao: 'ONLINE'
      },
      {
        tipoOperacao: 'UNDOING',
        descricao: 'UNDOING'
      },
      {
        tipoOperacao: 'TED',
        descricao: 'TED'
      },
      {
        tipoOperacao: 'CANCELLATION',
        descricao: 'CANCELLATION'
      },

    ];

    this.formConsultaFinanceira = this.formBuilder.group({
      dataInicio: [null],
      dataFim: [null],
      tipoConta: [null],
      tipoOperacao: [null],
    });

    this.columnsTabe = [
      { columnName: "establishmentName", newColumnName: "Nome Estabelecimento" },
      { columnName: "employeeName", newColumnName: "Nome" },
      { columnName: "amount", newColumnName: "Valor" },
      { columnName: "operationSign", newColumnName: "Operacao" },
      { columnName: "typeTransaction", newColumnName: "Tipo Transacao" },
      { columnName: "transactionDate", newColumnName: "Data Transacao" },
    ]

  }

  buscarConsulta(data?: any, page?: string) {

    let params = new HttpParams();

    if (data.tipoConta === null) {
      this.notificationService.error('Campo Tipo da Conta é obrigatório!');
    } else if (data.tipoOperacao === null) {
      this.notificationService.error('Campo Tipo Operação é obrigatório!');
    } else {

      if (data.tipoConta != null) {
        params = params.append('tipoConta', data.tipoConta)
      }
      if (data.tipoOperacao != null) {
        params = params.append('tipoOperacao', data.tipoOperacao)
      }
      if (data.dataInicio != null) {
        let dataInicio = this.dateUtilService.datepickerTransformDate(data.dataInicio, 'YYYY-MM-DD');
        params = params.append('dataInicio', dataInicio)
      }
      if (data.dataFim != null) {
        let dataFim: any = this.dateUtilService.datepickerTransformDate(data.dataFim, 'YYYY-MM-DD');
        params = params.append('dataFim', dataFim)
      }

      params = params.append('size', String(this.tableLimit))

      if (page) {
        params = params.append('page', page)
      }


      this.service.buscaConsultaFinanceira(params, (response => {

        this.rowData = response.content
        this.extrato = response.content.length;
        this.rowData = this.rowData.map(data => {
          return {
            establishmentName: data.establishmentName,
            employeeName: data.employeeName,
            amount: data.amount,
            operationSign: data.operationSign,
            typeTransaction: data.typeTransaction,
            transactionDate: this.dateUtilService.formatDate(data.transactionDate, "DD-MM-YYYY")
          }
        })

        this.paginationService.setInfo(response)

        if (this.extrato == 0) {
          this.notificationService.warn('Não há dados nesse período!');
        }

      }), null);


    }


  }

  buscarConsultaTotal(data?: any) {

    let params = new HttpParams();

    params = params.append('allElements', 'true');


    if (data) {

      if (data.dataInicio != null) {
        let dataInicio = this.dateUtilService.datepickerTransformDate(data.dataInicio, 'YYYY-MM-DD');
        params = params.append('dataInicio', dataInicio)
      }
      if (data.dataFim != null) {
        let dataFim: any = this.dateUtilService.datepickerTransformDate(data.dataFim, 'YYYY-MM-DD');
        params = params.append('dataFim', dataFim)
      }

    }

    this.service.buscaConsultaFinanceira(params, (response => {

      this.rowData = response.content
      this.extrato = response.content.length;
      this.rowData = this.rowData.map(data => {
        return {
          establishmentName: data.establishmentName,
          employeeName: data.employeeName,
          amount: data.amount,
          operationSign: data.operationSign,
          typeTransaction: data.typeTransaction,
          transactionDate: moment(data.transactionDate).format('DD/MM/YYYY'),
        }
      })

      if (this.extrato == 0) {
        this.notificationService.warn('Não há dados para exportar!');
      }

      this.exportCsvService.exportCsv(this.rowData, this.columnsTabe, ',', 'extratoLote');

    }), null);

  }

  ngOnInit() {

    this.datatableService.subscribeTable(this.myTable);

  }

  isCPF(): boolean {
    return this.cnpjCpf == null ? true : this.cnpjCpf.length < 12 ? true : false;
  }

  getCpfCnpjMask(): string {
    return this.isCPF() ? '000.000.000-009' : '00.000.000/0000-00';
  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

}
